var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapMarkerBlack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.463,
    height: 37.071,
    viewBox: "0 0 26.463 37.071",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5317",
    "data-name": "Group 5317",
    transform: "translate(-1073.969 -539)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5315",
    "data-name": "Group 5315",
    transform: "translate(1073.969 539)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3555",
    "data-name": "Path 3555",
    d: "M1087.2,576.071a.855.855,0,0,1-.813-.591c-1.563-4.811-4.136-7.642-6.626-10.379-2.978-3.276-5.791-6.369-5.791-12.165,0-7.944,5.688-13.936,13.23-13.936s13.232,5.992,13.232,13.936c0,5.8-2.814,8.889-5.792,12.164-2.49,2.738-5.063,5.569-6.626,10.38A.856.856,0,0,1,1087.2,576.071Zm0-35.361c-6.568,0-11.521,5.255-11.521,12.226,0,5.135,2.478,7.86,5.347,11.015a30.891,30.891,0,0,1,6.174,8.843,30.9,30.9,0,0,1,6.174-8.843c2.869-3.156,5.348-5.88,5.348-11.015C1098.722,545.965,1093.768,540.71,1087.2,540.71Z",
    transform: "translate(-1073.969 -539)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5316",
    "data-name": "Group 5316",
    transform: "translate(1080.683 545.799)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3556",
    "data-name": "Path 3556",
    d: "M1088.28,559.817a6.433,6.433,0,1,1-.034-12.865h.009a6.433,6.433,0,1,1,.025,12.865Zm-.034-11.155a4.617,4.617,0,0,0-4.714,4.717,4.723,4.723,0,1,0,9.446,0,4.617,4.617,0,0,0-4.713-4.717Z",
    transform: "translate(-1081.822 -546.952)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarkerBlack);
export default __webpack_public_path__ + "static/media/map-marker-black.e915ade2bfc8e673663ad28cd15544bb.svg";
export { ForwardRef as ReactComponent };